<template>
    <div class="body">
      <div class="header">
        <el-form :model="ImpositionFileDTO" :inline="true">
   
          <el-form-item>
             
            <el-button class="btn-style btn-redownload" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button class="btn-style btn-delete" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
  

  
        <div style="display: flex">
          <el-upload
            class="upload-demo"
            action="#"
            accept="xlsx,xls"
            multiple
            :limit="1"
            :auto-upload="false"
            :with-credentials="false"
            :show-file-list="false"
          >
          <!-- <el-button size="small" type="primary">导入</el-button> -->
          </el-upload>
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
         
        </div>
        
      </div>
      <div class="pagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="schemeName"
            align="center"
            label="底板雕刻设置名称"
          ></el-table-column>
          <el-table-column
            prop="cuttingNumber"
            align="center"
            label="切断刀编号"
          ></el-table-column>
          <el-table-column
            prop="slottingNumber"
            align="center"
            label="铣槽刀具编号"
          ></el-table-column>
          <el-table-column
            prop="openingNumber"
            align="center"
            label="切孔刀具编号"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="设置时间"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>

      <el-dialog title="编辑底板设置" :visible.sync="dialogVisible"  
                 text-align="center"
                :close-on-click-modal="false"
                class="order-dialog"
                width="75%"
                center>
        <el-form
        ref="accountForm"
                    :model="accountForm"
                    class="demo-accountForm form-style"
        >
        <div class="accountForm-header">
  
        <el-row :gutter="24">
          <el-col :span="8">
        <el-form-item label="底板雕刻设置名称" prop="outreachValue">
            <el-input v-model="accountForm.schemeName"  class="input-name" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item   label="雕刻机类型" prop="remark">
          <el-select clearable size="small" v-model="accountForm.machineType">
            <el-option
              v-for="item in machineType"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
        </el-col>
        </el-row>
    <el-divider><h1  class="drspen">铣槽刀</h1></el-divider>

          
    <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="铣槽刀具编号" prop="panelMaterial">
            <el-input v-model="accountForm.slottingNumber"  class="input-name"
        size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最大厚壁" prop="maximumWall">
            <el-input v-model="accountForm.maximumWall"  class="input-name"
              size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="最小厚壁" prop="minimumWall">
            <el-input v-model="accountForm.minimumWall"  class="input-name"
              size="small"></el-input>
          </el-form-item>
        </el-col>
           </el-row>

           <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item   label="铣槽刀雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.slottingDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
            <el-col :span="8">
          <el-form-item label="铣槽刀进给量" prop="panelMaterial">
            <el-input v-model="accountForm.slottingLoad"  class="input-name"
        size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="铣槽刀转速" prop="panelMaterial">
            <el-input v-model="accountForm.slottingSpeed"  class="input-name"
           size="small"></el-input>
          </el-form-item>
        </el-col>
           </el-row>

           <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="铣槽刀下刀Z值" prop="outreachValue">
            <el-input v-model="accountForm.slottingCutz"  class="input-name"
            size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="铣槽刀抬刀z值" prop="panelMaterial">
            <el-input v-model="accountForm.slottingKnifez"  class="input-name"
            size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="铣槽刀具直径" prop="panelMaterial">
            <el-input v-model="accountForm.slottingDiameter"  class="input-name"
          size="small"></el-input>
          </el-form-item>
        </el-col>
           </el-row>
           
           
           <el-divider><h1  class="drspen">切孔刀</h1></el-divider>


           <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="切孔刀具编号" prop="panelMaterial">
            <el-input v-model="accountForm.openingNumber"  class="input-name"
          size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item   label="切孔刀雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.openingDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
            <el-col :span="8">
          <el-form-item label="切孔刀进给量" prop="panelMaterial">
            <el-input v-model="accountForm.openingLoad"  class="input-name"
            size="small"></el-input>
          </el-form-item>
        </el-col>
           </el-row>

           <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="切孔刀转速" prop="panelMaterial">
            <el-input v-model="accountForm.openingSpeed"  class="input-name"
              size="small"></el-input>
          </el-form-item>    
        </el-col>
            <el-col :span="8">
          <el-form-item label="切孔刀下刀Z值" prop="outreachValue">
            <el-input v-model="accountForm.openingCutz"  class="input-name"
              size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="切孔刀抬刀z值" prop="panelMaterial">
            <el-input v-model="accountForm.openingKnifez"  class="input-name"
              size="small"></el-input>
          </el-form-item>
        </el-col>
           </el-row>

           <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="切孔刀具直径" prop="panelMaterial">
            <el-input v-model="accountForm.openingDiameter"  class="input-name"
            size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
           <el-form-item   label="切孔切边是否合并" prop="remark">
          <el-select clearable size="small" v-model="accountForm.edgeCutting">
            <el-option
              v-for="item in edgeCutting"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
           </el-row>

       
           <el-divider><h1  class="drspen">切断刀</h1></el-divider>

           <el-row :gutter="24">
          <el-col :span="8">
          <el-form-item label="切断刀编号" prop="outreachValue">
            <el-input v-model="accountForm.cuttingNumber"  class="input-name" size="small"></el-input>
          </el-form-item>
        </el-col>
                  <el-col :span="8">
          <el-form-item   label="切断刀雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.cuttingDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item> 
            </el-col>
              </el-row>

      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="切断刀进给量" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingLoad"  class="input-name"
        size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="切断刀抬刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingKnifez"  class="input-name"
        size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="切断刀下刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingCutz"  class="input-name"
        size="small"></el-input>
          </el-form-item>
        </el-col>
           </el-row>

           <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="切断刀转速" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingSpeed"  class="input-name"
          size="small"></el-input>
          </el-form-item>
        </el-col>
            <el-col :span="8">
          <el-form-item label="切断刀直径" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingDiameter"  class="input-name"
        size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">  
          <el-form-item   label="切断刀顺序" prop="remark">
          <el-select clearable size="small" v-model="accountForm.cuttingOrder">
            <el-option
              v-for="item in order"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
           </el-row>


        </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>

      </el-dialog>
      <password ></password>
    </div>
  </template>
  
  <script>
   import password from '@/components/password.vue';
   import {selectCarving,addCarving,bathDeleteCarving,upDateCarving} from '@/api/set/floorCarving'

  export default {
    components: {
      password
  },
    data() {
      return {
      direction: 'rtl',
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        drawer: false,
        access: '',
        date: '',
        dialogVisible: false,
        conTract: [],
        machineType:[{
        value: '0',
        label: '横版'
      }, {
        value: '1',
        label: '竖版'
      }, {
        value: '2',
        label: '横版和竖版'
      },{
        value: '3',
        label: '竖版逆向'
      }],
        directionStatus:[{
        value: '0',
        label: '顺时针'
      }, {
        value: '1',
        label: '逆时针'
      }],
      edgeCutting:[{
        value: '0',
        label: '合并'
      }, {
        value: '1',
        label: '不合并'
      }],
      order:[{
        value: 0,
        label: '顺序'
      }, {
        value: 1,
        label: '逆序'
      }],
        accountForm: {
          schemeName:'',
          cuttingNumber: '',
          cuttingDirection:'',
          cuttingLoad: '',
          cuttingKnifez:'',
          cuttingCutz:'',
          cuttingSpeed:'',
          cuttingDiameter:'',
          cuttingOrder:'',
          
          slottingNumber: '',
          slottingDirection:'',
          slottingLoad: '',
          slottingSpeed:'',
          slottingCutz:'',
          slottingKnifez:'',
          slottingDiameter:'',

          openingNumber: '',
          openingDirection:'',
          openingLoad: '',
          openingSpeed:'',
          openingCutz:'',
          openingKnifez:'',
          openingDiameter:'',
          maximumWall:'',
          minimumWall:'',
          edgeCutting:'',
          id:'',
          access:''
        },
        ImpositionFileDTO:{
            startTime: '',
            endTime: '',
           
            status: '2'
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
        }
      }
    },
    
  
    mounted() {
      
      this.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      getTableData() {
        selectCarving(this.access).then((res) => {
            console.log(res);
          this.conTract = res.data.data
        //  this.total = Number(res.data.data.total)
        })
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.dialogVisible = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        if(this.conTract[0]){
          this.accountForm =row;
        }
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addCarving(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleDelete() {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选任何文件呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            bathDeleteCarving(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     
  
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      //修改
      editAccount() {
        upDateCarving(this.accountForm).then((res) => {
          console.log(res.status)
          this.getTableData()
           
          if (res.data.msg === '操作成功') {
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
          } else if (res.data.msg !== '操作成功') {
            this.$message({
                type: 'info',
                message: res.data.data
              })
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.ImpositionFileDTO.startTime = e[0]
          this.ImpositionFileDTO.endTime = e[1]
        } else if (!e) {
          this.ImpositionFileDTO.startTime = ''
          this.ImpositionFileDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
  
    
    }
  }
  </script>
  

  <style lang="scss" scoped>
  .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin: 20px;
  }
  
  .body {
      overflow: auto;
  }
  
  .pagination {
      margin-top: 10px;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;
  }
  
  .el-pagination /deep/ .el-pagination__total {
      line-height: 36px;
  }
  
  .el-table .warning-row {
      background: oldlace;
  }
  
  .el-table .success-row {
      background: #f0f9eb;
  }
  .goodsTableData{
      margin: 20px 0 ;
  }
  .btn-style{
      min-width: 72px;
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-buy{
      background: #FF8429;
  }
  .btn-print{
      background: #4093FF;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-view{
      background: var(--theme-color);
  }
  .product-form .el-form-item{
      margin-bottom: 0;
  }
  .table-content{
      margin: 20px;
  }
  .check-all{
      color: #333;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
  }
  .el-pagination{
      margin: 0;
  }
  
  .el-date-editor , /deep/ .el-select .el-input__inner , /deep/ .el-input .el-input__inner{
      border-radius: 8px;
  }
  
  .table-label{
      color: var(--secondColor);
  }
  .table-value{
      color: var(--color);
  }
  .table-info{
      width: 80%;
      justify-content: space-between;
  }
  .table-info > p{
      display: inline-block;
      width: 150px;
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-shrink: 0;
  }
  .el-divider--vertical {
  display: inline-block;
  //weight: 1px;
  height: 70%;
  margin: 0 8px;
  background: 0 0;
  border-left: 2px dashed #e8eaec;
  position: relative;
}
  .table-item{
      background: #F7F7F7;
      margin: 8px 0;
      border-radius: 12px;
      padding: 12px;
  }
  .table-image{
      width: 100px;
      height: 50px;
      margin-right: 20px;
  }
  /deep/ .table-image .image-slot{
      height: 50px;
      display: flex;
      align-items: center;
  }
  /deep/ .table-image .image-slot i{
      font-size: 50px;
  }
  .pay{
      color:var(--theme-color);
  }
  .drspen{
    font-family: "Algerian";
            color: rgb(139, 0, 12);
  }
  .no-pay{
      color:#FF4D4D;
  }
  .btn-group{
      display: flex;
      flex-direction: column;
      gap: 10px;
  }
  .btn-group .el-button{
      border-radius: 20px;
      width: 76px;
  }
  .btn-collection{
      background: #F9DDDD;
  }
  .btn-view-detail{
      background: #D3F2E4;
      color: var(--theme-color);
  }
  .btn-reckon{
      background: rgb(245, 233, 212);
    
  }
  
  /deep/ .order-dialog .el-dialog{
      border-radius: 24px;
  }
  .operator label{
      letter-spacing: 5px;
  }
  /deep/ .dialog-upload{
      display: flex;
  }
  /deep/ .dialog-upload .el-form-item__label{
      flex-shrink: 0;
  }
  /deep/ .dialog-upload .el-form-item__content{
      justify-content: right;
  }
  /deep/ .dialog-upload .avatar-uploader{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #D8E0DD;
  }
  /deep/ .dialog-upload .el-upload--text{
      width: 100%;
      height: 100%;
  }
  /deep/ .dialog-upload img{
      max-width: 100px;
  }
  .accountForm-header{
      background: #F7F7F7;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px;
  }
  .btn-add{
      background: #FF8429;
      border-radius: 8px;
  }
  .form-submit{
      background: var(--theme-color);
      border-radius: 8px;
  }
  /deep/ .el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .table-no-pay{
      background: #ffeded;
  }
  
  /deep/ .el-icon-remove-outline{
      font-size: 32px;
      color: #a3d8f9cc;
  }
  </style>
  